// extracted by mini-css-extract-plugin
export default {"spinner":"spinnerLoader_spinner__rzDrP","spin":"spinnerLoader_spin__r8i4i"};